export default __webpack_public_path__ + "static/media/Friends.db52e9ef.webp";